export default class ProcessingProgressBar {
    constructor(connectionIds = []) {
        this.connectionIds = connectionIds ?? [];
        this.updateProgressBars = this.updateProgressBars.bind(this);
        this.interval = null;

        if (this.connectionIds.length > 0) {
            this.interval = window.setInterval(() => {
                this.updateProgressBars();
            }, 2000);
        }
    }

    static init() {
        const connectionIds = [];
        $("[data-processing-progress-bar-connection-id]").each((_, element) => {
            connectionIds.push($(element).data("processingProgressBarConnectionId"));
        });

        return new ProcessingProgressBar(connectionIds);
    }

    updateProgressBars() {
        if (this.connectionIds.length === 0 && this.interval) {
            window.clearInterval(this.interval);
            this.interval = null;
            return;
        }

        $.ajax({
            url: "/admin/connection/processing-progress-bar",
            method: "POST",
            data: {
                connection_ids: this.connectionIds
            },
            success: (response) => {
                if (!response || response.status !== "success") {
                    return;
                }

                Object.entries(response.htmls).forEach(([connectionId, html]) => {
                    // Převedeme connectionId na číslo pro správné porovnání
                    const numericConnectionId = parseInt(connectionId, 10);

                    if (!html) {
                        this.connectionIds = this.connectionIds.filter(id => id !== numericConnectionId);
                    } else {
                        const progressBar = $(`[data-processing-progress-bar-connection-id="${connectionId}"]`);
                        if (progressBar.length === 0) {
                            return;
                        }
                        progressBar.replaceWith(html);
                    }
                });
                window.tooltipStart();
            },
            error: (error) => {
                console.error("Chyba při načítání průběhu připojení:", error);
            }
        });
    }
}
